import { Input, Directive, TemplateRef, ContentChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  DeleteDialogDataWithTemplate,
  DeleteDialogComponent,
  DeleteDialogAction,
  deleteDefaults
} from './delete-dialog.component';

@Directive({
  selector: 'delete-dialog',
  exportAs: 'deleteDialog',
  standalone: false
})
export class DeleteDialogDirective implements DeleteDialogDataWithTemplate {
  @Input() deleteText: string = deleteDefaults.deleteText;
  @Input() secondaryText: string;
  @Input() noText: string = deleteDefaults.noText;
  @Input() header: string = deleteDefaults.header;
  @Input() width: number = deleteDefaults.width;
  @Input() onDelete: () => Promise<boolean> = deleteDefaults.onDelete;

  @Input() onSecondary: () => void;
  @Input() minHeightPx?: number;
  //Whether the user can use escape or clicking on the backdrop to close the modal
  @Input() disableClose: boolean = deleteDefaults.disableClose;
  @Input() formGroup: FormGroup;

  @ContentChild(TemplateRef) template: TemplateRef<any>;
  @ContentChild('bottomSection') bottomSection: TemplateRef<any>;

  constructor(private dialog: MatDialog) {}

  //called from HTML ex. (click)="infoModal.open()"
  open = (
    configOverrides: Partial<DeleteDialogDataWithTemplate> = {}
  ): Promise<DeleteDialogAction> =>
    DeleteDialogComponent.openFromDirective(this.dialog, this, configOverrides);

  close() {
    this.dialog.closeAll();
  }
}
